<ion-select
    (ionBlur)="notifyTouched?.()"
    [formControl]="gradeLevels"
    [label]="label"
    [multiple]="multiple"
    fill="outline"
    labelPlacement="floating"
    [interface]="interface"
>
    @for (gradeLevel of options; track gradeLevel) {
        <!-- Don't surround the option with spaces or they will show up in the list -->
        <ion-select-option [value]="gradeLevel">{{
            'enums.gradeLevel.' + gradeLevel | translate
        }}</ion-select-option>
    }
</ion-select>
